import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { getCurrentTextLanguage } from '../../../helpers/helpers'
import styles from './basketItem.module.scss'
import { Words } from '../../../types/lang'
import { RootState } from '../../../redux/store'

interface BasketItemProps {
  name: any
  language: string
  words: Words
  count: number
  price: number
  id: string
  setDisplayNone: any
}

const BasketItem = ({
  name,
  language,
  words,
  count,
  price,
  id,
  setDisplayNone,
}: BasketItemProps) => {
  const [bookName, setBookName] = useState('')
  useEffect(() => {
    setBookName(getCurrentTextLanguage(name))
  }, [])

  useEffect(() => {
    setBookName(getCurrentTextLanguage(name))
  }, [language])

  return (
    <div className={styles.container}>
      <div className={styles.item}>
        <NavLink to={`/books/${id}/${name.eng}`} className={styles.itemName}>
          {bookName}
        </NavLink>
        <div className={styles.itemCount}>x&nbsp;{count}</div>
        <div className={styles.itemPrice}>{price}&nbsp;€</div>
      </div>
    </div>
  )
}

let mapStateToProps = (state: RootState) => {
  return {
    words: state.main.words,
    language: state.main.language,
  }
}
//@ts-ignore
export default connect(mapStateToProps, {})(BasketItem)
